<template>
  <div
    :style="{ position: 'absolute', top: '18px', right: '20px', 'z-index': 3 }"
  >
    <rg-video-play-back-button
      class="aisea-text-12-400-pure-white"
      :disabled="disabled"
      buttonText="カメラ録画再生"
      :handleClick="handleClick"
    ></rg-video-play-back-button>
  </div>
</template>

<script>
import RgVideoPlayBackButton from "./RgVideoPlayBackButton.vue";

export default {
  name: "RgVideoPlayBackButtonContainer",
  props: {
    handleClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RgVideoPlayBackButton,
  },
};
</script>

<style lang="scss" scoped></style>
